import {Injectable} from '@angular/core';
import {MdDialog, MdDialogConfig, MdSnackBar, MdSnackBarConfig} from '@angular/material';
import {DeleteItemDialogComponent} from '../../components/delete-item-dialog/delete-item-dialog.component';
import 'rxjs/add/operator/skipWhile';
import 'rxjs/add/operator/do';
import {Observable} from 'rxjs/Observable';
import {FailedDeleteItemDialogComponent} from '../../components/failed-delete-item-dialog/failed-delete-item-dialog.component';
/**
 * Component mainly used for launching the DeleteItemDialogComponent
 */
@Injectable()
export class DeleteItemService {

  constructor(public dialog: MdDialog, public snackBar: MdSnackBar) { }

  /**
   *
   * @param {string} name Name of the item to delete
   * @param {string} title Title to be displayed at the top of the dialog
   * @param {string} description Description of the consequences for deleting
   * @param {number} id ID of the item to delete
   * @return {Observable<number>} when a user deletes an item
   */
  openDialog(name: string, title: string, description: string, id: number): Observable<number> {
    return this.dialog
      .open(DeleteItemDialogComponent, <MdDialogConfig> {
        // data to be passed in
        data: {
          name: name,
          title: title,
          description: description,
          id: id
        }
      })
      .afterClosed()
      .skipWhile((value) => value !== id)
      .do(() => this.snackBar.open('Item deleted!', 'Dismiss', <MdSnackBarConfig>{duration: 3000}));
  }
  openNegativeDialog(name: string, title: string, description: string, id: number): Observable<number> {
      return this.dialog
          .open(FailedDeleteItemDialogComponent, <MdDialogConfig> {
              // data to be passed in
              data: {
                  name: name,
                  title: title,
                  description: description,
                  id: id
              }
          })
          .afterClosed()
          .skipWhile((value) => value !== id)
          .do(() => this.snackBar.open('Item deleted!', 'Dismiss', <MdSnackBarConfig>{duration: 3000}));
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/services/delete-item/delete-item.service.ts